import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { map, Observable } from 'rxjs';
import { ActivityService } from '@core/services/activity.service';
import { RelatedToType } from '@shared/enums';
import { Activity, FieldDef } from '@core/models';
import { Project, Property } from '@modules/projects/projects.types';

@Component({
  selector: 'app-field-history',
  templateUrl: './field-history.component.html',
  styleUrls: ['./field-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldHistoryComponent {
  @Input({ required: true }) model: Project | Property | any;
  @Input({ required: true }) fieldDef: FieldDef;
  @Input({ required: true }) data: any;
  @Input() multiFields = false;
  @Input() relatedToType: RelatedToType;

  get options(): any {
    return this.data?.options;
  }

  activities$: Observable<Activity[]>;

  constructor(private readonly activityService: ActivityService) {}

  ngOnInit(): void {
    if (this.multiFields && Array.isArray(this.fieldDef)) {
      this.setActivitiesBasedOnFieldDef({
        related_to_id: this.model.id,
        field: (this.fieldDef as FieldDef[]).map((x) => x.name).join(','),
        related_to_type: this.relatedToType,
        per_page: 100,
      });
      return;
    }

    if (this.fieldDef.related_to_type === RelatedToType.Task) {
      this.setActivitiesBasedOnFieldDef({
        related_to_id: this.model.id,
        field: this.fieldDef.name,
        related_to_type: this.fieldDef.related_to_type,
      });
    } else if (this.fieldDef.custom_object_id) {
      this.setActivitiesBasedOnFieldDef({
        related_to_id: this.model.related_to_id || this.model.id,
        field: this.fieldDef.name,
        related_to_type: RelatedToType.CustomObjectValue,
      });
    } else {
      this.setActivitiesBasedOnFieldDef({
        related_to_type: this.fieldDef.related_to_type,
        related_to_id: this.model.id,
        field: this.fieldDef.name,
      });
    }
  }

  private setActivitiesBasedOnFieldDef(params: any): void {
    this.activities$ = this.activityService.getActivities(params).pipe(map(({ activities }) => activities));
  }

  getFieldDef(fieldName: string): FieldDef {
    if (Array.isArray(this.fieldDef)) {
      return (this.fieldDef as FieldDef[]).find((x) => x.name === fieldName);
    }

    return this.fieldDef;
  }
}
